import React from "react";

import {connect} from "react-redux";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import Loader from "react-loader-spinner";

import SearchBar from "./search-bar";
import NavBar from "../navBar";
import Footer from "../footer";
import {fetchProducts, filterProducts, saveKeyword, searchProduct, setLoading} from "../../../_actions/search.action";
import SearchResult from "./search-results";

class ContainingResult extends React.Component {

  componentWillMount() {
    var searchData = localStorage.getItem("searchData");

    this.props.searchProduct(searchData);
    this.props.fetchProducts(searchData);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.props.searchProduct(this.props.text);
      this.props.fetchProducts(this.props.text);
    }
  }

  render() {
    const {loading, loader} = this.props;

    if (loading) {
      return null;
    }

    return (
      <React.Fragment>
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <div class="col">
              <NavBar></NavBar>
            </div>
          </div>
          <SearchBar searchType={localStorage.getItem("searchType")}></SearchBar>
          <div class="row no-gutters">
            <div class="col">
              <div className="row">
                <div className="col-8 offset-2 resultSearchBar">

                </div>
              </div>
              {(loader === true) && <center><Loader type="ThreeDots" color="#00BFFF"></Loader></center>}
              <br/><br/>
              <div className="row">
                <div className="col-sm-8 col-md-6 offset-sm-2 offset-md-3">
                  <div class="row">
                    <div className="col-10 offset-1"/>
                    <SearchResult {...this.props} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col">
              <Footer></Footer>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.product.loading,
  loader: state.product.loader,
  text: state.product.text,
  product: state.product.products
});

export default connect(mapStateToProps, {
  searchProduct,
  fetchProducts,
  setLoading,
  saveKeyword,
  filterProducts
})(ContainingResult);
